module.exports = __webpack_public_path__ + "img/icon-order.f4a472af.png";